const disabledValues = new Set(["false", "0", "no", "off"]);

const isEnabled = (value, defaultValue = true) => {
  if (value === undefined || value === null || value === "") {
    return defaultValue;
  }

  return !disabledValues.has(String(value).trim().toLowerCase());
};

export const featureFlags = {
  workflows: isEnabled(process.env.REACT_APP_ENABLE_WORKFLOWS, true),
  aiChat: isEnabled(process.env.REACT_APP_ENABLE_AI_CHAT, true),
};
